import React from "react";

import { classNames } from "@oneleet/utils/src/utils";

import { Highlight, themes } from "prism-react-renderer";
import { twMerge } from "tailwind-merge";

import { CopyButton } from "../../..";

const theme = themes.nightOwl;

interface CodeBlockProps {
  language?: string;
  content: string;
  copyable?: boolean;
  withLineDecorators?: boolean;
  className?: string;
}

const CodeBlock: React.FC<CodeBlockProps> = ({
  language = "text",
  content,
  copyable = true,
  withLineDecorators = false,
  className,
}) => {
  return (
    <div className={twMerge("relative", className)}>
      <Highlight
        theme={theme}
        code={content ? content.trim() : ""}
        language={language}
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <pre
            className={classNames(
              className,
              "flex items-start gap-2 rounded-md p-4 text-sm",
            )}
            style={style}
          >
            <code className="grow self-center overflow-x-auto text-sm">
              {tokens.map((line, i) => (
                <div key={i} {...getLineProps({ line })}>
                  {withLineDecorators && (
                    <span className="select-none pr-4 opacity-50">
                      {language === "bash" && line[0]?.content.trim()
                        ? "$"
                        : language !== "bash"
                          ? i + 1
                          : ""}
                    </span>
                  )}
                  {line.map((token, key) => (
                    <span key={key} {...getTokenProps({ token })} />
                  ))}
                </div>
              ))}
            </code>
            {copyable && <CopyButton content={content} />}
          </pre>
        )}
      </Highlight>
    </div>
  );
};

export default CodeBlock;
